module.exports = __webpack_public_path__ + "img/icon_1.9db1e645.png";